import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-generic-accordion-group-v2',
    templateUrl: './generic-accordion-group-v2.component.html',
    styleUrls: ['./generic-accordion-group-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericAccordionGroupV2Component {

  constructor() { }

}
